import React from 'react';
import { X, Check } from 'lucide-react';
export function Comparison() {
  const withoutItems = ['Llevás trabajo a casa todos los días', 'Improvisás informes sin estructura', 'Perdés horas haciendo registros', 'Dudás en reuniones con familias', 'No tenés modelos de adaptaciones', 'Te sentís sin respaldo profesional'];
  const withItems = ['Terminás todo en tu horario', 'Informes con modelos listos', 'Registros organizados y completos', 'Comunicación profesional resuelta', 'Adaptaciones listas para usar', 'Trabajo ordenado y documentado'];
  return <section className="w-full bg-white py-10 px-4" data-id="element-48">
      <div className="max-w-4xl mx-auto" data-id="element-49">
        <div className="grid grid-cols-2 gap-3" data-id="element-50">
          {/* SIN */}
          <div className="bg-red-50 rounded-lg p-3 border-2 border-red-200" data-id="element-51">
            <h3 className="text-sm md:text-lg font-bold text-red-700 mb-3 text-center" data-id="element-52">
              ❌ SIN el Megapack
            </h3>
            <ul className="space-y-2" data-id="element-53">
              {withoutItems.map((item, index) => <li key={index} className="flex items-start gap-1.5" data-id="element-54">
                  <X className="w-4 h-4 text-red-600 flex-shrink-0 mt-0.5" data-id="element-55" />
                  <span className="text-xs md:text-sm text-gray-700 leading-tight" data-id="element-56">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          {/* CON */}
          <div className="bg-teal-50 rounded-lg p-3 border-2 border-teal-600" data-id="element-57">
            <h3 className="text-sm md:text-lg font-bold text-teal-700 mb-3 text-center" data-id="element-58">
              ✅ CON el Megapack
            </h3>
            <ul className="space-y-2" data-id="element-59">
              {withItems.map((item, index) => <li key={index} className="flex items-start gap-1.5" data-id="element-60">
                  <Check className="w-4 h-4 text-teal-600 flex-shrink-0 mt-0.5" data-id="element-61" />
                  <span className="text-xs md:text-sm text-gray-700 leading-tight" data-id="element-62">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>

        <p className="text-center text-lg md:text-xl font-semibold text-gray-800 italic mt-8 max-w-2xl mx-auto" data-id="element-63">
          Si cada alumno te obliga a empezar de cero, nunca vas a tener tiempo
          suficiente.
        </p>
      </div>
    </section>;
}